import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import LeftIcon from '@material-ui/icons/ChevronLeft';
import RightIcon from '@material-ui/icons/ChevronRight';
import IconButton from '@material-ui/core/IconButton';

const IconPager = ({
  currentIndex,
  totalCount,
  performPrevious,
  performNext,
  icon,
  loop
}) => {
  return (
    <InfoContainer
      style={{ margin: '10px 20px 5px 10px', alignItems: 'center' }}
    >
      <div style={{ display: 'flex' }}>
        <IconButton
          onClick={() => performPrevious()}
          disabled={!loop ? currentIndex === 0 : !loop}
          style={{ padding: 0 }}
          /* style={{
            padding: 0,
            color: currentIndex === 0 ? 'rgba(255,255,255,0.25)' : '#fff',
          }} */
        >
          <LeftIcon />
        </IconButton>
        <img src={icon} />
        <IconButton
          onClick={() => performNext()}
          disabled={!loop ? currentIndex === totalCount - 1 : !loop}
          style={{ padding: 0 }}
          /* style={{
            padding: 0,
            color:
              currentIndex === totalCount - 1
                ? 'rgba(255,255,255,0.25)'
                : '#fff',
          }} */
        >
          <RightIcon />
        </IconButton>
      </div>
      <span style={{ fontSize: 11, marginTop: 5 }}>
        <b>{currentIndex + 1}</b> of <b>{totalCount}</b>
      </span>
    </InfoContainer>
  );
};

IconPager.propTypes = {
  currentIndex: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  performPrevious: PropTypes.func.isRequired,
  performNext: PropTypes.func.isRequired,
  icon: PropTypes.any,
  loop: PropTypes.any.isRequired
};

IconPager.defaultProps = {
  loop: true
};

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export default IconPager;